module.exports = __webpack_public_path__ + "static/media/icon-double-caret-next.5056c1f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-double-caret-next.svg
// module id = 1237
// module chunks = 19